module.exports = __webpack_public_path__ + "img/qa.77c88638.svg";